import { Dispatch, SetStateAction } from 'react';
import './pager.scss';

function Pager({
    elements,
    page,
    setPage,
    numberOfResults
} : {
    page: number,
    setPage: Dispatch<SetStateAction<number>>,
    elements: any[],
    numberOfResults: number
}) {
    return (
        <div className="pager">
            {page > 1 ? <i className="fal fa-angle-left" onClick={() => setPage(--page)}></i> : <i className="fal fa-angle-left disabled"></i>}
            <div className="paging-numbers">
                {page > 3 && page > Math.floor(elements.length / numberOfResults) ? <span onClick={() => setPage(page - 4)}>{page - 4}</span> : ''}
                {page > 2 && page > Math.floor(elements.length / numberOfResults - 1) ? <span onClick={() => setPage(page - 3)}>{page - 3}</span> : ''}
                {page > 2 ? <span onClick={() => setPage(page - 2)}>{page - 2}</span> : ''}
                {page >= 2 ? <span onClick={() => setPage(page - 1)}>{page - 1}</span> : ''}
                <span className="active">{page}</span>
                {page <= Math.floor(elements.length / numberOfResults) ? <span onClick={() => setPage(page + 1)}>{page + 1}</span> : ''}
                {page < Math.floor(elements.length / numberOfResults) ? <span onClick={() => setPage(page + 2)}>{page + 2}</span> : ''}
                {elements.length > numberOfResults * 2 && page < 3 ? <span onClick={() => setPage(page + 3)}>{page + 3}</span> : ''}
                {elements.length > numberOfResults * 2 && page < 2 ? <span onClick={() => setPage(page + 4)}>{page + 4}</span> : ''}
            </div>
            {page <= Math.floor(elements.length / numberOfResults) ? <i className="fal fa-angle-right" onClick={() => setPage(++page)}></i> : <i className="fal fa-angle-right disabled"></i>}
        </div>
    )
}

export default Pager;